export default {
      id: "ic_mobile_game_search-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_mobile_game_search-usage",
      toString: function () {
        return this.url;
      }
    }